import styles from './LocalePickerAndSocialLinks.module.scss';
import React, { FC } from 'react';
import { FooterLocalePicker } from 'components/Footer/LocalePickerAndSocialLinks/FooterLocalePicker/FooterLocalePicker';
import { FooterSocialLinks } from 'components/Footer/LocalePickerAndSocialLinks/FooterSocialLinks/FooterSocialLinks';
import { Grid } from 'components/Grid/Grid';
import { FlatEntry } from 'services/cms/flattenContentful';
import { ExternalLink } from 'api/contentful/contentTypes.cloverdotcom';

interface ILocalePickerAndSocialLinksProps {
  socialLinks?: FlatEntry<ExternalLink>[];
}

export const LocalePickerAndSocialLinks: FC<ILocalePickerAndSocialLinksProps> = ({ socialLinks }) => {
  return (
    <Grid item container gutter className={styles.container}>
      <Grid item xs>
        <FooterLocalePicker />
      </Grid>
      {socialLinks && (
        <Grid item xs="auto">
          <FooterSocialLinks items={socialLinks} />
        </Grid>
      )}
    </Grid>
  );
};
